import axios from 'axios';
import config from 'commons-vehicle/config/index.js';
import { ConfigsService, LocaleService } from '@sm360/widget-commons-core-services';
import ShowroomAPIService from 'commons-vehicle/services/ShowroomService/ShowroomAPIService.js';

class PurchaseMethodsService {
    constructor() {
        this.basePath = `${config.endpoint.showroom}/service/v1`;
    }

    /**
     * getPaymetOptionsV25 - To get paymentOptions data from desking API for Calculator and pricing Component For VDP
     * @param [payLoad] payLoad pass as request body for desking/paymentOptions API
     */
    getPurchaseMethodsV25(payLoad) {
        const orgId = ConfigsService.getOrganizationId();
        const orgUnitId = ConfigsService.getOrganizationUnitId();
        const location = ConfigsService.getOrganizationUnitLocation();
        const language = LocaleService.getLocale();
        const context = `?lang=${language}&location=${location}&orgId=${orgId}&orgUnitId=${orgUnitId}&module=2`;
        // Get JWT public token
        return ShowroomAPIService.getPublicToken().then(({ data: token }) => {
            return axios
                .post(`${this.basePath}/quote/desking/paymentOptions/${context}`, payLoad, {
                    headers: {
                        'x-jwt': token,
                    },
                })
                .then(({ data: paymentOptions }) => {
                    return Promise.resolve(paymentOptions);
                });
        });
    }

    /**
     * getPaymentRollV25 - To get cash down amount from desking API for Calculator based on provided target payment value
     * @param [payLoad] - Target payment value along with other required params
     */
    getPaymentRollV25(payLoad) {
        const orgId = ConfigsService.getOrganizationId();
        const orgUnitId = ConfigsService.getOrganizationUnitId();
        const location = ConfigsService.getOrganizationUnitLocation();
        const context = `?lang=en-CA&location=${location}&orgId=${orgId}&orgUnitId=${orgUnitId}&module=2`;
        // Get JWT public token
        return ShowroomAPIService.getPublicToken().then(({ data: token }) => {
            return axios
                .post(`${this.basePath}/quote/desking/paymentRoll/${context}`, payLoad, {
                    headers: {
                        'x-jwt': token,
                    },
                })
                .then(({ data: paymentRoll }) => {
                    return Promise.resolve(paymentRoll);
                });
        });
    }

    getFormattedCurrencySplit(formattedCurrency) {
        const formattedCurrencySplit = {
            beforeDecimal: '',
            afterDecimal: '',
        };
        let decimalPoint = formattedCurrency.indexOf('.');
        if (decimalPoint === -1) {
            decimalPoint = formattedCurrency.indexOf(',');
        }
        if (decimalPoint > -1) {
            formattedCurrencySplit.beforeDecimal = formattedCurrency.substring(0, decimalPoint);
            formattedCurrencySplit.afterDecimal = formattedCurrency.substring(
                decimalPoint + 1,
                formattedCurrency.length
            );
        } else {
            formattedCurrencySplit.beforeDecimal = formattedCurrency;
        }
        return formattedCurrencySplit;
    }
}

export default new PurchaseMethodsService();
